<template>
    <div style="overflow: visible;" class="modal fade" :id="name"  :aria-labelledby="name" aria-hidden="true">
        <div class="modal-dialog">
            <modal-content class="modal-content" :id="'content-'+name">
                <div class="modal-header" style="height: auto;">
                    <slot name="modal-header"></slot>
                    <button 
                        type="button" 
                        class="close"
                        @click.prevent="$root.closeModalApp(name)">
                        &times;
                    </button>
                </div>
                <slot></slot>
            </modal-content>
        </div>
    </div>
</template>

<script>
import { CModalContent } from './Styles/Template/styled'
export default {
    name:'ModalApp',
    props: {
        name:{required:true}
    },
    components: {
        'modal-content': CModalContent
    }
}
</script>